import type { FormRequiredFields, FormValues, InputIDs } from '../types';
import type { SuccessPageProps } from '../SuccessPage';
import type { SchemaType } from '../helpers/validationSchema';
import type { PostDataMessage } from './helpers/handleSubmit';

export enum GeneralFormTestIds {
  main = 'contactform-container',
  header = 'contactform-header',
  form = 'contactform-form',
}

export type FormDevice = 'web' | 'tab' | 'mob' | 'app';

export type GeneralFormProps = {
  /** Object containing the initial Form values */
  initialValues: FormValues;
  /** Yup Validation Schema */
  validationSchema: SchemaType;
  /** Array of required Fields */
  requiredFields: FormRequiredFields;
  /** Fields that you want to prefill with user's data (if logged in) */
  fieldsToPrefill: InputIDs[];
  /** Function to convert the form's data into data to post */
  convertFormDataToPostData: (formValues: FormValues) => PostDataMessage;
  successPage: SuccessPageProps;
  /** Texts for the submit button */
  submitButton: { enabled: string; disabled: string };
  /** Headline and description above the form. Will not be rendered if ommitted */
  headingArea?: { headline: string; description: string };
  /** Card Header directly above the form. Will not be rendered if ommitted  */
  formHeading?: string;
  /** Enter custom placeholder and label for the message field  */
  customMessageField?: { placeholder: string; label: string };
  /** Render the subject selection */
  showSubject?: boolean;
  /** Render checkboxes */
  showOptions?: boolean;
  /** Render a checkbox above the submit button */
  showTerms?: boolean;
  /** Render the salutation selection */
  showSalutation?: boolean;
  /** Render the birthday input instead of the phone input */
  showBirthdate?: boolean;
};
